import { render, staticRenderFns } from "./OrderInfoDetails.vue?vue&type=template&id=a2b9ead8&scoped=true"
import script from "./OrderInfoDetails.vue?vue&type=script&lang=ts"
export * from "./OrderInfoDetails.vue?vue&type=script&lang=ts"
import style0 from "./OrderInfoDetails.vue?vue&type=style&index=0&id=a2b9ead8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b9ead8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2b9ead8')) {
      api.createRecord('a2b9ead8', component.options)
    } else {
      api.reload('a2b9ead8', component.options)
    }
    module.hot.accept("./OrderInfoDetails.vue?vue&type=template&id=a2b9ead8&scoped=true", function () {
      api.rerender('a2b9ead8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrderInfoDetails.vue"
export default component.exports